


import React, { useState } from 'react';
import { Box, Button, Typography, Divider, Alert, CircularProgress } from '@mui/material';
import axios from "../components/api";

const Sidebar = ({ setSelectedSession, sessions }) => {
    const [file, setFile] = useState(null);
    const [loadingAction, setLoadingAction] = useState(null); // "upload", "replace", "delete"
    const [message, setMessage] = useState(null); // success or error

    const handleUpload = async (type) => {
        if (!file) {
            setMessage({ type: "error", text: "Please choose a file first." });
            return;
        }

        setMessage(null);
        setLoadingAction(type);

        const formData = new FormData();
        formData.append("file", file);
        const endpoint = type === "upload" ? "/upload" : "/replace";

        try {
            const response = await axios.post(endpoint, formData);
            setMessage({ type: "success", text: `${type.charAt(0).toUpperCase() + type.slice(1)} successful: ${response.data.uploaded || response.data.replaced} chunks` });
        } catch (err) {
            const errorText = err.response?.data?.detail || "Something went wrong.";
            setMessage({ type: "error", text: `${type} failed: ${errorText}` });
        }

        setLoadingAction(null);
    };

    const handleDelete = async () => {
        if (!file) {
            setMessage({ type: "error", text: "Please choose a file to delete." });
            return;
        }

        setMessage(null);
        setLoadingAction("delete");

        try {
            const response = await axios.delete(`/delete/${file.name}`);
            setMessage({ type: "success", text: `Deleted ${response.data.deleted} chunks.` });
        } catch (err) {
            const errorText = err.response?.data?.detail || "Delete failed.";
            setMessage({ type: "error", text: errorText });
        }

        setLoadingAction(null);
    };

    return (
        <Box
            sx={{
                width: "280px",
                height: "100vh",
                backgroundColor: "#1e1e1e",
                boxShadow: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 2,
                gap: 2,
                // overflowY: "auto",
                color: "white"
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                 File Operations
            </Typography>

            <input type="file" onChange={(e) => setFile(e.target.files[0])} style={{ color: "white" }} />

            <Button
                onClick={() => handleUpload("upload")}
                fullWidth
                variant="contained"
                disabled={loadingAction !== null}
                sx={{ fontWeight: "bold" }}
            >
                {loadingAction === "upload" ? <CircularProgress size={20} color="inherit" /> : "Upload"}
            </Button>

            <Button
                onClick={() => handleUpload("replace")}
                fullWidth
                variant="contained"
                disabled={loadingAction !== null}
                sx={{ fontWeight: "bold" }}
            >
                {loadingAction === "replace" ? <CircularProgress size={20} color="inherit" /> : "Replace"}
            </Button>

            <Button
                onClick={handleDelete}
                fullWidth
                variant="contained"
                color="error"
                disabled={loadingAction !== null}
                sx={{ fontWeight: "bold" }}
            >
                {loadingAction === "delete" ? <CircularProgress size={20} color="inherit" /> : "Delete"}
            </Button>

            {message && (
                <Alert
                    severity={message.type}
                    sx={{ width: "100%", mt: 2, backgroundColor: message.type === "error" ? "#ffcccc" : "#d0ffd0", color: "#000" }}
                >
                    {message.text}
                </Alert>
            )}

            <Divider sx={{ my: 2, width: "100%", borderColor: "gray" }} />
        </Box>
    );
};

export default Sidebar;
